import { render, staticRenderFns } from "./partsReturnDialog.vue?vue&type=template&id=33a87637&scoped=true"
import script from "./partsReturnDialog.vue?vue&type=script&lang=js"
export * from "./partsReturnDialog.vue?vue&type=script&lang=js"
import style0 from "./partsReturnDialog.vue?vue&type=style&index=0&id=33a87637&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a87637",
  null
  
)

export default component.exports